import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import { FontAwesomeIcon } from '@magoosh/lib/icons';

import colors from '@magoosh/lib/styles/colors.module.scss';

interface Props {
  name: string;
  range: {
    low: {
      label: string;
      value: number;
    };
    high: {
      label: string;
      value: number;
    };
  };
  tooltip?: string;
  value: number;
  valueContext?: string;
}

export default (props: Props) => {
  let percentage = ((props.value - props.range.low.value) / (props.range.high.value - props.range.low.value)) * 100;
  percentage = Math.min(percentage, 100);
  percentage = Math.max(percentage, 0);

  return (
    <div className="d-flex flex-column gap-xs small">
      <div className="d-flex gap-s">
        {
          props.tooltip ? (
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip id={`facet-tooltip-${props.name}`}>
                  {props.tooltip}
                </Tooltip>
              }
            >
              <div>
                <strong className="text-underdash">{props.name}</strong> <FontAwesomeIcon icon="info-circle" />
              </div>
            </OverlayTrigger>
          ) : (
            <div><strong>{props.name}</strong></div>
          )
        }

        {props.valueContext && <div>({props.valueContext})</div>}
      </div>

      <div className="d-flex flex-1">
        <div className="text-gray-light">
          {props.range.low.label}
        </div>

        <div className="d-flex flex-1 justify-content-end text-gray-light">
          {props.range.high.label}
        </div>
      </div>

      <div style={{ height: 14, marginTop: 2, position: 'relative' }}>
        <div
          style={{
            background: colors.grayLighter,
            height: 4,
            position: 'absolute',
            width: '100%'
          }}
        />

        <div
          style={{
            background: colors.brandSecondary,
            position: 'absolute',
            height: 4,
            width: `${percentage}%`
          }}
        />

        <div
          style={{
            background: colors.brandSecondary,
            borderRadius: 14,
            color: '#fff',
            fontSize: 11,
            fontWeight: 'bold',
            height: 16,
            left: `max(0px, ${percentage}% - 30px)`,
            lineHeight: 'normal',
            paddingTop: 1,
            position: 'absolute',
            textAlign: 'center',
            top: -7,
            width: 30
          }}
        >
          {props.value}
        </div>
      </div>
    </div>
  );
};
